import { Col } from 'antd';
import { Row } from 'antd';
import { useState } from 'react';
import { Enviroment } from '../../../../../_config/constants/enviroment-v2.constant';
import CustomButton from '../../../../../v2-components/Antd/Button';
import CustomDivider from '../../../../../v2-components/Antd/Divider';
import CustomModal from '../../../../../v2-components/Antd/Modal';
import { approveButton } from './constants/approve-button.constant';
import { cancelButton } from './constants/cancel-button.constant';
import { statusNames } from './constants/status-names.constant';
import { getStatusDetail } from './handle/get-status-detail.handle';
import { hideButtons } from './handle/hide-buttons.handle';
import { confirmButton } from './constants/confirm-button.constant';
// import { showReverseButton } from './handle/show-reverse-button.handle';


export default function StatusCard(props) {
	const [openConfirm, setOpenConfirm] = useState(false);
	const [openCancel, setOpenCancel] = useState(false);

	const handleCancel = () => {
		setOpenCancel(true);
	};

	const handleReject = async () => {
		await props.handleCancelOrder();
		setOpenCancel(false);
	};

	const handleApprove = async () => {
		await props.handleApproveOrder();
		setOpenConfirm(false);
	};
	const handleNext = () => {
		setOpenConfirm(true);
	};

	return (
		<Row>
			<Row>
				<Col span={24}>
					<h3>Estado de la solicitud</h3>
					<span>{statusNames[Enviroment.LANGUAGE][props.statusNumber]}</span>
					<p>
						
						{
							props.status.status !== 8 
								? getStatusDetail(props.status, props.deliveryType, props.products)
								: null
						}
					</p>
				</Col>
			</Row>
			<Row style={hideButtons(props.status.status, props.deliveryType)}>
				<Col span={12}>
					<CustomButton style={{ backgroundColor: '#D2000C', color: '#FFFFFF' }} onClick={handleCancel}>
						{cancelButton[Enviroment.LANGUAGE][props.status.status]}
					</CustomButton>
				</Col>
				<Col span={12}>
					<CustomButton style={{ backgroundColor: '#088926', color: '#FFFFFF', marginLeft: '30px' }} onClick={handleNext}>
						{approveButton[Enviroment.LANGUAGE][props.status.status]}
					</CustomButton>
				</Col>
			</Row>
			{/* {showReverseButton(props)} */}

			<CustomModal onCancel={() => setOpenConfirm(false)} footer={null} open={openConfirm}>
				<h2>Avanzar</h2>
				<CustomDivider />
				<h5>Al darle a continuar estas confirmando que el estado está completo</h5>
				<p>Si estas de acuerdo dale a continuar</p>
				<CustomDivider />
				<div className="button-container">
					<CustomButton onClick={() => setOpenConfirm(false)}>Cancelar</CustomButton>
					<CustomButton onClick={handleApprove}>{confirmButton[Enviroment.LANGUAGE][props.status.status]}</CustomButton>
				</div>
			</CustomModal>

			<CustomModal onCancel={() => setOpenCancel(false)} footer={null} open={openCancel}>
				<h2>Cancelar compra</h2>
				<CustomDivider />
				<h4>Estás seguro de cancelar la compra?</h4>
				<p>Se le enviará al usuario una notificación con la anulación, junto con la fecha de reverso del pago</p>
				<CustomDivider />
				<div>
					<CustomButton onClick={() => setOpenCancel(false)}>Cancelar</CustomButton>
					<CustomButton onClick={handleReject}>Cancelar compra</CustomButton>
				</div>
			</CustomModal>
		</Row>
	);
}
